import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthorizationService as AUTHORIZATION } from "../../hezky-routes";

export const authGuard: CanActivateFn = () => {
  const authorization = inject(AUTHORIZATION);
  const router = inject(Router);
  if (authorization.isAuthenticated()) {
    return true;
  } else {
    router.navigate(['auth/login']);
    return false;
  }
};
